import { getLocationString } from '../../../../components/LocationSelect';
import { Candidate } from '../../../../entities/applicant_tracking/Candidate';
import { Application } from '../../../../entities/v1/applicant_tracking/Application';
import { CandidateDto } from '../../../../services/applicant_tracking/CandidateService/CandidateDto';

export function mergeCandidateApplications(
  candidate?: Candidate,
  application?: Application,
): CandidateDto {
  let referrerUserId, referrerEmail;
  if (application?.source?.sourceReferrer?.userId) {
    referrerUserId = application?.source?.sourceReferrer?.userId;
  } else {
    referrerEmail = application?.source?.sourceReferrer?.email;
  }

  const existingCandidate = application?.candidate || candidate;
  const locationName = getLocationString(candidate);

  return {
    id: existingCandidate?.id,
    firstName: existingCandidate?.firstName,
    lastName: existingCandidate?.lastName,
    email: existingCandidate?.email,
    phoneNumber: existingCandidate?.phoneNumber,
    address: existingCandidate?.address,
    location: {
      name: locationName,
      address: existingCandidate?.address,
      city: existingCandidate?.city,
      state: existingCandidate?.stateCode,
      country: existingCandidate?.countryCode,
    },
    candidateId: existingCandidate?.id,
    status: existingCandidate?.status,
    documents: application?.documents?.map((a) => {
      return {
        filename: a.filename,
        id: a.id,
        size: a.size,
      };
    }),
    resume: {
      filename: application?.applicationResume?.filename,
      id: application?.applicationResume?.id,
      size: application?.applicationResume?.size,
    },
    coverLetter: {
      filename: application?.applicationCoverLetter?.filename,
      id: application?.applicationCoverLetter?.id,
      size: application?.applicationCoverLetter?.size,
    },
    company: application?.currentCompany,
    jobTitle: application?.currentTitle,
    yearsExperience: application?.experience,
    academicDegree: application?.academicDegree,
    linkedinUrl: candidate?.linkedinUrl,
    portfolioUrl: application?.portfolioUrl,
    jobPostId: application?.jobPostId,
    salaryExpectation: application?.expectedSalary,
    salaryCurrency: application?.salaryCurrency,
    referralKnowledge: application?.referralKnowledge,
    referrerUserId: referrerUserId,
    referrerEmail: referrerEmail,
    sourceId: application?.sourceId?.toString(),
    hasWorkingVisa: application?.hasWorkingVisa,
    candidateDetail: application?.details,
    jobStageId: application?.jobStageId,
  };
}
